import { apiATC } from '../config';

const BASE = `${apiATC}/import-atc`;

function toError(payload, fallbackMessage) {
  const message = payload?.error || payload?.message || fallbackMessage;
  const err = new Error(message);
  if (payload && typeof payload === 'object') err.payload = payload;
  return err;
}

/**
 * Envoie les lignes parsées du XLSX au backend pour analyse et matching.
 * @param {object} params
 * @param {number} params.clientId
 * @param {'vente'|'stock'} params.type
 * @param {Array}  params.rows    - lignes extraites avec le mapping
 * @param {object} params.mapping - { id_fact: colIdx, ref_fournisseur: colIdx, ... }
 * @returns {{ matched, ambiguous, unmatched, duplicates }}
 */
export async function analyseImport({ clientId, type, rows, mapping }) {
  const res = await fetch(`${BASE}/analyse.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId, type, rows, mapping }),
  });
  const data = await res.json();
  if (!res.ok) throw toError(data, "Erreur lors de l'analyse");
  return data;
}

/**
 * Envoie les lignes résolues (ambiguïtés tranchées) pour insertion finale.
 * @param {object} params
 * @param {number} params.clientId
 * @param {'vente'|'stock'} params.type
 * @param {Array}  params.resolved - lignes avec id_of définitif
 * @returns {{ inserted, duplicates, ignored }}
 */
export async function resolveImport({ clientId, type, resolved }) {
  const res = await fetch(`${BASE}/resolve.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId, type, resolved }),
  });
  const raw = await res.text();
  let data = null;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch (error) {
    data = { error: 'Réponse invalide du serveur', raw };
  }
  if (!res.ok) throw toError(data, "Erreur lors de l'import");
  if (data === null) throw toError({ error: 'Réponse vide du serveur' }, 'Réponse vide du serveur');
  return data;
}
